export const ASC = 'asc';
export const DESC = 'desc';

export const toggleSortDirection = direction => {
  if (direction === ASC) {
    return DESC;
  } else {
    return ASC;
  }
};



// WEBPACK FOOTER //
// ./src/utils/sortDirections.js